export default "__VITE_ASSET__Cp5L6QwI__"